namespace e5 {
    export interface TextAreaOptions {
        width: number;
        lineHeight: number;
        x: number;
        y: number;
    }

    export interface RoundRectRadius {
        tl?: number;
        tr?: number;
        bl?: number;
        br?: number;
        [corner: string]: number;
    }

    export class Draw {
        public static textArea(ctx: CanvasRenderingContext2D, text: string, options: TextAreaOptions, calcOnly: boolean = false): number {
            var words: string[] = text.split(" ");
            var line = words.shift();
            var lineHeight = 20;
            var yPos = options.y;
            var xPos = options.x;
            for (var word of words) {
                if (ctx.measureText(line + word).width > options.width) {
                    if (!calcOnly)
                        ctx.fillText(line, xPos, yPos);
                    yPos += lineHeight;
                    line = "";
                }
                line += (line.length > 0 ? " " : "") + word;
            }
            if (line.length > 0) {
                if (!calcOnly)
                    ctx.fillText(line, xPos, yPos);
            }

            return yPos - options.y;
        }

        public static roundRect(ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number, radius: RoundRectRadius | number = 0): void {
            var cornerRadius: RoundRectRadius;
            if (typeof radius === "object") {
                cornerRadius = { tl: 0, tr: 0, bl: 0, br: 0 };
                for (var corner in radius) {
                    cornerRadius[corner] = radius[corner];
                }
            } else if (typeof radius === "number") {
                cornerRadius = { tl: radius, tr: radius, bl: radius, br: radius };
            }

            ctx.beginPath();
            ctx.moveTo(x + cornerRadius.tl, y);
            ctx.lineTo(x + width - cornerRadius.tr, y);
            ctx.quadraticCurveTo(x + width, y, x + width, y + cornerRadius.tr);
            ctx.lineTo(x + width, y + height - cornerRadius.br);
            ctx.quadraticCurveTo(x + width, y + height, x + width - cornerRadius.br, y + height);
            ctx.lineTo(x + cornerRadius.bl, y + height);
            ctx.quadraticCurveTo(x, y + height, x, y + height - cornerRadius.bl);
            ctx.lineTo(x, y + cornerRadius.tl);
            ctx.quadraticCurveTo(x, y, x + cornerRadius.tl, y);
            ctx.closePath();
            ctx.fill();
        }
    }
}